import { AppState } from 'Store'

const getItems = (state: AppState) => state.registratorCabinet.sberGeoAddress.items
const getParams = (state: AppState) => state.registratorCabinet.sberGeoAddress.params

export const sberGeoAddress = {
	getItems,
	getParams,
}
